<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="pa-0">
        <v-card-title class="ma-0 pa-0">
          <v-row class="ma-0" no-gutters justify="end">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("settings.landlordValidityPlan.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                class="mx-2"
                :placeholder="$t('settings.landlordValidityPlan.planName')"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item
                  @click="showRightSideDrawer('LANDLORD_VALIDITY_PLAN')"
                >
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("settings.landlordValidityPlan.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="landlordValidityPlansTable"
          :hide-default-footer="footer"
          :headers="headers"
          :items="landlordValidityPlanLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          class="pa-0 mt-2 datatable"
          :server-items-length="totalLandlordValidityPlan"
        >
          <!-- for subArea expand table  -->
          <!-- :expanded.sync="expanded"
          show-expand
          single-expand
          item-key="_id" -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  landlordValidityPlanLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto">
              <v-icon
                color="primary"
                class="mx-auto"
                @click="editLandlordValidityPlan(item)"
                >mdi-pencil</v-icon
              >
            </v-row>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-row class="mx-auto">
              <v-switch
                v-if="!footer"
                class="mx-auto"
                v-model="item.isActive"
                @change="toggleLandlordValidityPlan(item)"
              >
              </v-switch>
              <span v-else>{{ item.isActive ? "true" : "false" }}</span>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { toggleLandlordValidityPlan } from "../methods/landlord_validity_plan/toggle_landlord_validity_plan_status";
export default {
  data() {
    return {
      expanded: [],
      footer: false,
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landlordValidityPlanLists: [],
      totalLandlordValidityPlan: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "center",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.landlordValidityPlan.planName")}`,
          align: "center",
          value: "planName",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.landlordValidityPlan.validity")}`,
          align: "center",
          value: "validity",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.landlordValidityPlan.price")}`,
          align: "center",
          value: "price",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.landlordValidityPlan.currency")}`,
          align: "center",
          value: "currency",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("settings.landlordValidityPlan.noOfRooms"),
          value: "numberOfUnits",
          sortable: false,
          align: "center",
          width: 100
        },
        {
          text: this.$t("settings.landlordValidityPlan.status"),
          align: "center",
          value: "isActive",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          align: "center",
          width: 100
        }
      ];
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandlordValidityPlan,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandlordValidityPlan,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getAllLandlordValidityPlan() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
        variables: {
          input: {
            limit: this.totalLandlordValidityPlan,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.landlordValidityPlanLists = this.$format.cloneVariable(
            data.getAllLandlordValidityPlan.landlordValidityPlans
          );
          this.loading = loading;
          this.totalLandlordValidityPlan =
            data.getAllLandlordValidityPlan.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("toggleItems", data => {
      if (data.module === "landlordValidityPlan") {
        toggleLandlordValidityPlan({
          id: data.item._id,
          status: data.item.isActive
        }).then(({ data }) => {
          if (data.toggleLandlordValidityPlan) {
            this.$store.commit("TOGGLE_BTN_LOADING", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: "Status Changed Successfully",
              color: "green"
            });
            this.$root.$emit("refetchLandlordValidityPlan");
          }
        });
      }
    });
    this.$root.$on("landlordValidityPlanTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchLandlordValidityPlan", () => {
      this.loading = true;
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandlordValidityPlan,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: ""
        }
      });
      this.loading = false;
    });
    this.$root.$on("searchLandlordValidityPlan", data => {
      this.search = data;
    });
    this.$root.$on("exportLandlordValidityPlan", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getAllLandlordValidityPlan
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(response => {
          this.options.itemsPerPage =
            response.data.getAllLandlordValidityPlan.totalCount;
          this.landlordValidityPlansLists =
            response.data.getAllLandlordValidityPlan.landlordValidityPlans;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel(
              "landlordValidityPlansTable",
              "landlordValidityPlans"
            );
          }, 1000);
        });
    },
    toggleLandlordValidityPlan(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "landlordValidityPlan"
      });
    },
    editLandlordValidityPlan(item) {
      this.$store.commit("IS_EDIT_LANDLORD_VALIDITY_PLAN", true);
      this.$store.commit("EDIT_LANDLORD_VALIDITY_PLAN", item);
      this.$store.commit("APP_SETTINGS_FORMNAME", "LANDLORD_VALIDITY_PLAN");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("landlordValidityPlanTable");
    this.$root.$off("refetchlandLordValidityPlan");
    this.$root.$off("exportLandlordValidityPlan");
    this.$root.$off("searchLandlordValidityPlan");
  }
};
</script>
<style scoped>
.custom-data-table {
  background: #ffffff !important;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2) !important;
}
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
